var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("svg", { class: _vm.iconClass, style: _vm.iconStyle }, [
    _c("use", {
      attrs: {
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xlink:href": _vm.iconName
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }